<template>
  <svg version="1.1" class="table-config-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 35 35" width="22px" height="22px" style="enable-background:new 0 0 35 35;" xml:space="preserve">
    <path d="M18.253,26.563h-8.7c-1.103,0-2-.897-2-2v-14c0-1.103.897-2,2-2h8.7c1.103,0,2,.897,2,2v14c0,1.103-.897,2-2,2ZM9.553,10.563v14h8.7v-14h-8.7ZM26.932,26.563h-2.045c-1.103,0-2-.897-2-2v-14c0-1.103.897-2,2-2h2.045c1.103,0,2,.897,2,2v14c0,1.103-.897,2-2,2ZM24.887,10.563v14h2.045v-14h-2.045Z"/>
  </svg>
</template>
